import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import config from "../../config";
import CRC32 from "crc-32";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import Footer from "../shared/Footer";

function PaymentResponse({ setEnvironment, environment }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [statusData, setStatusData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loading2, setLoading2] = useState(false);
  const [error, setError] = useState(null);


  const orderId = searchParams.get("order_id");

  useEffect(() => {
    if (!orderId) {
      setError("Missing order ID in URL.");
      setLoading(false);
      return;
    }
    const token = sessionStorage.getItem("tokenclassx");

    if (!token) {
      navigate("/");
      return;
    }
    const fetchTransactionStatus = async () => {
      try {
        const response = await fetch(
          `${config.API_BASE_URL}/GET_TRANSACTION_STATUS_BY_ORDER_ID`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ ORDER_ID: orderId }),
          }
        );

        if (!response.ok) {
          const msg = await response.text();
          throw new Error(`Server responded with ${response.status}: ${msg}`);
        }

        const result = await response.json();
        // console.log(result);
        const orderid = result.data.OrderId;
        const transactionamount = result.data.TransactionAmount;
        const paymentstatus = result.data.PaymentStatus;
        setStatusData(result.data);
        sessionStorage.setItem("PaymentStatus", paymentstatus);
        // setLoading(false);
        const count = parseInt(sessionStorage.getItem("count") || "1", 10);
        let status = ''
        if (paymentstatus === "S") {
          status = 'SUCCESS';
        } else if (paymentstatus === "P") {
          status = 'PENDING';
        } else if (paymentstatus === "F") {
          status = 'FAILED';
        } else {
          status = '';
        }
        paymentActivity(status);

        if (paymentstatus === "P" && count === 1) {
          setLoading2(true);
          sessionStorage.setItem("count", "2");
          setTimeout(() => {
            handleProceedToPayment(orderid, transactionamount);
          }, 3000);
        }
      } catch (err) {
        // setLoading(false);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTransactionStatus();
  }, [orderId]);

  const paymentActivity = async (paymenyStatus) => {
    const token = sessionStorage.getItem("tokenclassx");
    try {
      const response = await fetch(`${config.API_BASE_URL}/InsertLogDataStudentLogin`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ROLL_CODE: sessionStorage.getItem("rollcode"),
          ROLL_NO: sessionStorage.getItem("rollnumber"),
          CONTACT_NO: sessionStorage.getItem("phoneNumber"),
          ACTIVITY: paymenyStatus
        }),
      });

      if (response.ok) {
        const result = await response.json();
      } else {
        const error = await response.text();
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
    }
  }
  const formatNumber = (number, decimals) => {
    return parseFloat(number).toFixed(decimals);
  };

  const generateChecksum = (message, secretKey) => {
    const fullMessage = message + "|" + secretKey;
    return CRC32.str(fullMessage) >>> 0; // ensure unsigned
  };

  const handleProceedToPayment = (orderid, transactionamount) => {
    const orderId = orderid || "N/A";
    const customerId =
      sessionStorage.getItem("rollcode") +
      "-" +
      sessionStorage.getItem("rollnumber");
    const transactionAmount = transactionamount;
    const requestDateTime = new Date()
      .toLocaleDateString("en-GB")
      .split("/")
      .join("-");
    const isProd = environment === "NO";
    const url = isProd
      ? config.PAYMENT_LINK_PRODUCTION
      : config.PAYMENT_LINK_DEV;
    const responseUrl = isProd
      ? config.PAYMENT_RESPONSE_URL_DEV
      : config.PAYMENT_RESPONSE_URL_DEV;
    const serviceId = isProd
      ? config.SERVICE_ID_PRODUCTION
      : config.SERVICE_ID_DEV;
    const merchantId = isProd
      ? config.MERCHANT_ID_PRODUCTION
      : config.MERCHANT_ID_DEV;
    const secretKey = isProd
      ? config.SECRET_KEY_PRODUCTION
      : config.SECRET_KEY_DEV;
    const currency = config.REACT_APP_CURRENCY || "INR";
    const messageType = config.MESSAGE_TYPE || "AR";
    const additionalFields = ["test1", "test2", "test3", "test4", "test5"];
    const formattedAmount = formatNumber(transactionAmount, 2);
    const msg = [
      messageType,
      merchantId,
      serviceId,
      orderId,
      customerId,
      formattedAmount,
      currency,
      requestDateTime,
      responseUrl,
      responseUrl,
      ...additionalFields,
    ].join("|");
    const checksum = generateChecksum(msg, secretKey);
    const form = document.createElement("form");
    form.name = "URL";
    form.method = "POST";
    form.enctype = "multipart/formdata";
    form.action = url;

    const appendHidden = (name, value, addBreaks = true) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.value = value;
      input.setAttribute("readonly", ""); // Correctly add readonly
      form.appendChild(input);

      if (addBreaks) {
        form.appendChild(document.createElement("br"));
        form.appendChild(document.createElement("br"));
      }
    };

    appendHidden("messageType", messageType);
    appendHidden("merchantId", merchantId);
    appendHidden("serviceId", serviceId);
    appendHidden("currencyCode", currency);
    appendHidden("successUrl", responseUrl);
    appendHidden("failUrl", responseUrl);
    appendHidden("orderId", orderId);
    appendHidden("customerId", customerId);
    appendHidden("transactionAmount", formattedAmount);
    appendHidden("requestDateTime", requestDateTime);

    additionalFields.forEach((field, index) => {
      const isLast = index === additionalFields.length - 1;
      appendHidden(`additionalField${index + 1}`, field, !isLast);
    });

    appendHidden("checksum", checksum, false); // No breaks after last input

    // console.log("Generated Payment Form HTML:");
    // console.log(form.outerHTML);

    // Uncomment to actually submit
    document.body.appendChild(form);
    form.submit();
  };

  const getStatusStyles = (status) => {
    switch (status) {
      case "F":
        return {
          backgroundColor: "#dc3545",
          icon: "fa-times",
          label: "Payment Failed",
          buttonClass: "btn-danger",
        };
      case "P":
        return {
          backgroundColor: "#ffc107",
          icon: "fa-clock-o",
          label: "Payment Pending",
          buttonClass: "btn-warning",
        };
      default:
        return {
          backgroundColor: "#28a745",
          icon: "fa-check",
          label: "Payment Successful",
          buttonClass: "btn-success",
        };
    }
  };

  if (loading) {
    return (
      <div className="custom-loader-container">
        <div className="custom-loader"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center mt-5 text-danger">
        <h4>Error: {error}</h4>
      </div>
    );
  }

  const { backgroundColor, icon, label, buttonClass } = getStatusStyles(
    statusData?.PaymentStatus
  );

  return (
    <>
      {loading2 && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <div class="container-scroller">
        <Navbar />
        <div class="container-fluid page-body-wrapper">
          <Sidebar />
          <div class="main-panel">
            <div class="content-wrapper payment-page">
              <section class="content-header mb-5">
                {/* <h3 class="content-header-text">
                  WELCOME, {sessionStorage.getItem("candidatename")}
                </h3> */}

              </section>

              <div
                className="card text-center"
                style={{
                  padding: "40px",
                  borderRadius: "12px",
                  boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
                  borderBottom: `5px solid ${backgroundColor}`,
                  width: "490px",
                }}
              >
                <div
                  style={{
                    backgroundColor,
                    width: "70px",
                    height: "70px",
                    borderRadius: "50%",
                    margin: "0 auto",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <i
                    className={`fa ${icon}`}
                    style={{ color: "white", fontSize: "32px" }}
                    aria-hidden="true"
                  ></i>
                </div>

                <h3 style={{ marginTop: "20px", marginBottom: "30px" }}>
                  {label}
                </h3>

                <div className="text-left" style={{ marginTop: "20px" }}>
                  <div className="d-flex justify-content-between mb-2">
                    <strong>Order ID</strong>{" "}
                    <span>{statusData?.OrderId || "-"}</span>
                  </div>
                  {statusData?.PaymentStatus !== "F" && (
                    <div className="d-flex justify-content-between mb-2">
                      <strong>Transaction ID</strong>{" "}
                      <span>{statusData?.BankTransactionNo || "-"}</span>
                    </div>
                  )}

                  <div className="d-flex justify-content-between mb-2">
                    <strong>Transaction Amount</strong>{" "}
                    <span>
                      {statusData?.TransactionAmount
                        ? `${statusData.TransactionAmount}/-`
                        : "-"}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <strong>Transaction Date & Time</strong>{" "}
                    <span>{statusData?.ResponseDateTime || ""}</span>
                  </div>

                  <button
                    className={`btn ${buttonClass}`}
                    style={{ marginTop: "50px" }}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/dashboard");
                    }}
                  >
                    Back to Dashboard <i className="fa fa-arrow-right ml-2"></i>
                  </button>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default PaymentResponse;
